/*
  SolarGen · DC-Kabel-Auswahl im Set-Konfigurator (siehe snippets/sg-dc-kabel.liquid)
  ----------------------------------------------------------------
  Alle Events laufen per Delegation am document. Der Soft-Swap beim
  Modul-Wechsel ersetzt die ganze Produkt-Section, gebundene Listener
  waeren danach weg; die Delegation ueberlebt das.

  Oeffentliche API fuer die Konfigurator-Snippets:
    SGDcKabel.find(scope)            -> [data-sg-kabel] im Scope oder null
    SGDcKabel.deltaCents(el)         -> Aufpreis in Cent
    SGDcKabel.lengths(el)            -> [2, 2, 5, 5]
    SGDcKabel.setLengths(el, arr)    -> Auswahl uebernehmen (z. B. nach Modul-Wechsel)
    SGDcKabel.cartConfigId(el, vid)  -> gemeinsame ID fuer Set-Zeile und Kabelzeilen
    SGDcKabel.cartItems(el, opts)    -> Positionen fuer cart/add.js

  Aendert sich die Auswahl, feuert 'sg:dc-kabel:change' (bubbelt) am Element.

  Verfuegbarkeit: Angeboten werden nur Laengen mit variant.available. Der
  Bestand kommt aus data-variants (Liquid) und wird beim Laden, beim Oeffnen
  des Panels und vor dem Hinzufuegen live ueber /products/<handle>.js
  abgeglichen. Nicht lieferbare Wahl faellt auf 2 m zurueck. Ist 2 m selbst
  nicht lieferbar, ist der Block "aus" (is-off): keine Kabelzeilen, kein
  Aufpreis, das Set bleibt bestellbar.
*/
(function () {
  if (window.SGDcKabel) return;

  var HANDLE = 'dc-kabel-zum-set';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FRESH_MS = 20000;
  var MSG_BLOCKED = 'Eine gewählte Kabellänge ist gerade nicht lieferbar. Wir haben sie auf 2 m zurückgesetzt. Bitte prüfe die Auswahl und lege das Set erneut in den Warenkorb.';
  var MSG_OFF_BLOCKED = 'Kabel sind gerade nicht lieferbar. Das Set kannst du ohne Kabel bestellen, bitte lege es erneut in den Warenkorb.';

  function variants(el) {
    if (!el._sgkVariants) {
      try { el._sgkVariants = JSON.parse(el.getAttribute('data-variants') || '[]'); }
      catch (e) { el._sgkVariants = []; }
    }
    return el._sgkVariants;
  }
  function variantFor(el, m) {
    var list = variants(el);
    for (var i = 0; i < list.length; i++) if (list[i].m === m) return list[i];
    return null;
  }
  function availableFor(el, m) {
    var v = variantFor(el, m);
    return v && v.a !== false ? v : null;
  }
  function isOff(el) {
    return !availableFor(el, 2);
  }
  function lines(el) {
    return Array.prototype.slice.call(el.querySelectorAll('[data-sg-kabel-mod]'));
  }
  function lengths(el) {
    return lines(el).map(function (l) { return parseInt(l.getAttribute('data-value'), 10) || 2; });
  }
  function deltaCents(el) {
    if (isOff(el)) return 0;
    return lengths(el).reduce(function (sum, m) {
      var v = variantFor(el, m);
      return sum + (v ? v.cents : 0);
    }, 0);
  }
  function formatEur(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  /* Zaehlt Laengen: {2: [1, 2], 5: [3, 4]} (Modulnummern ab 1) */
  function groups(el) {
    var out = {};
    lengths(el).forEach(function (m, i) {
      (out[m] = out[m] || []).push(i + 1);
    });
    return out;
  }

  /* Optionen aller Dropdowns aus den lieferbaren Varianten neu aufbauen.
     Nur Dropdowns mit abweichender Liste, sonst bleibt das Liquid-Markup. */
  function syncOptions(el) {
    var avail = variants(el).filter(function (v) { return v.a !== false; })
      .sort(function (a, b) { return a.m - b.m; });
    var want = avail.map(function (v) { return String(v.m); }).join(',');

    lines(el).forEach(function (line) {
      var sel = line.querySelector('select');
      if (!sel) return;
      var have = Array.prototype.map.call(sel.options, function (o) { return o.value; }).join(',');
      if (have === want) return;
      sel.innerHTML = '';
      avail.forEach(function (v) {
        sel.appendChild(new Option(v.l || (v.m + ' m'), String(v.m)));
      });
    });

    var all = el.querySelector('[data-sg-kabel-all]');
    if (all) {
      var haveAll = Array.prototype.filter.call(all.options, function (o) { return o.value; })
        .map(function (o) { return o.value; }).join(',');
      if (haveAll !== want) {
        Array.prototype.slice.call(all.options).forEach(function (o) { if (o.value) o.remove(); });
        avail.forEach(function (v) { all.appendChild(new Option(v.m + ' m', String(v.m))); });
      }
    }
  }

  /* Nicht lieferbare Wahl auf 2 m. Gibt true zurueck, wenn sich etwas geaendert hat. */
  function sanitize(el) {
    var touched = false;
    lines(el).forEach(function (line) {
      var m = parseInt(line.getAttribute('data-value'), 10) || 2;
      if (m !== 2 && !availableFor(el, m)) {
        line.setAttribute('data-value', '2');
        touched = true;
      }
    });
    return touched;
  }

  function showError(el, text) {
    var box = el.querySelector('[data-sg-kabel-error]');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  function render(el) {
    var off = isOff(el);
    el.classList.toggle('is-off', off);
    var sum = el.querySelector('[data-sg-kabel-sum]');
    var sub = el.querySelector('[data-sg-kabel-sub]');
    var extra = el.querySelector('[data-sg-kabel-extra]');
    var toggle = el.querySelector('[data-sg-kabel-toggle]');
    if (toggle) toggle.hidden = off;

    if (off) {
      if (sum) sum.textContent = 'derzeit nicht lieferbar';
      if (sub) sub.textContent = 'Kabel derzeit nicht lieferbar. Das Set kannst du trotzdem bestellen.';
      if (extra) extra.textContent = '';
      openPanel(el, false);
      return;
    }

    var g = groups(el);
    var keys = Object.keys(g).map(Number).sort(function (a, b) { return a - b; });
    if (sum) sum.textContent = keys.map(function (m) { return g[m].length + '× ' + m + ' m'; }).join(', ');

    var delta = deltaCents(el);
    if (extra) extra.textContent = delta > 0 ? '+ ' + formatEur(delta) : '';
    if (sub) sub.textContent = delta > 0 ? 'Aufpreis gegenüber 2 m inklusive' : '1 Kabelpaar pro Modul inklusive';

    lines(el).forEach(function (line) {
      var m = String(parseInt(line.getAttribute('data-value'), 10) || 2);
      var sel = line.querySelector('select');
      if (sel && sel.value !== m) sel.value = m;
      line.classList.toggle('is-changed', m !== '2');
    });

    /* "Alle Module" zeigt die gemeinsame Laenge, bei gemischter Wahl "unterschiedlich" */
    var all = el.querySelector('[data-sg-kabel-all]');
    if (all) {
      var ls = lengths(el);
      var same = ls.every(function (m) { return m === ls[0]; });
      all.value = same ? String(ls[0]) : '';
    }
  }

  function changed(el) {
    render(el);
    el.dispatchEvent(new CustomEvent('sg:dc-kabel:change', { bubbles: true, detail: { deltaCents: deltaCents(el) } }));
  }

  function setLengths(el, arr) {
    if (!el || !arr || !arr.length) return;
    var uniform = arr.every(function (m) { return m === arr[0]; });
    lines(el).forEach(function (line, i) {
      var m = uniform ? arr[0] : (arr[i] || 2);
      line.setAttribute('data-value', String(availableFor(el, m) ? m : 2));
    });
    if (!isOff(el) && !lengths(el).every(function (m) { return m === 2; })) openPanel(el, true);
    changed(el);
  }

  function openPanel(el, open) {
    var panel = el.querySelector('[data-sg-kabel-panel]');
    var btn = el.querySelector('[data-sg-kabel-toggle]');
    if (!panel || !btn) return;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Fertig' : 'Längen anpassen';
  }

  /* ---- Live-Bestand --------------------------------------------------- */

  var stock = null;      // { variantId: available }
  var stockAt = 0;
  var stockPromise = null;

  function loadStock() {
    if (stockPromise) return stockPromise;
    stockPromise = fetch(ROOT + 'products/' + HANDLE + '.js?_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        stock = {};
        (p.variants || []).forEach(function (v) { stock[v.id] = !!v.available; });
        stockAt = Date.now();
        return stock;
      })
      .catch(function () { return null; })
      .then(function (s) { stockPromise = null; return s; });
    return stockPromise;
  }

  /* Bestand auf ein Element anwenden. true, wenn sich die Auswahl aendern musste. */
  function applyStock(el) {
    if (stock) {
      variants(el).forEach(function (v) {
        if (Object.prototype.hasOwnProperty.call(stock, v.id)) v.a = stock[v.id];
        else v.a = false;
      });
    }
    var wasOff = el.classList.contains('is-off');
    syncOptions(el);
    var touched = sanitize(el);
    if (touched || wasOff !== isOff(el)) { changed(el); return touched; }
    render(el);
    return false;
  }

  function refresh(el) {
    return loadStock().then(function () { return applyStock(el); });
  }

  function initAll() {
    var els = document.querySelectorAll('[data-sg-kabel]');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (el) { applyStock(el); });
    loadStock().then(function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-sg-kabel]'), applyStock);
    });
  }

  /* Gleiche Konfiguration -> gleiche ID, damit Shopify identische Sets
     zusammenfasst und unterschiedliche getrennt haelt. */
  function cartConfigId(el, mainVariantId) {
    return String(mainVariantId) + ':' + lengths(el).join('-');
  }

  /* Eine Warenkorb-Position pro Laenge. Menge = Anzahl Module mit dieser
     Laenge x Set-Menge. _sg_kabel_cfg verbindet sie mit der Set-Zeile,
     _sg_kabel_pro_set erlaubt dem Guard, die Menge nachzuziehen.
     Ohne lieferbares 2-m-Kabel: keine Positionen, das Set geht allein. */
  function cartItems(el, opts) {
    opts = opts || {};
    if (isOff(el)) return [];
    var mainQty = Math.max(1, parseInt(opts.mainQty, 10) || 1);
    var cfg = cartConfigId(el, opts.mainVariantId || 0);
    var g = groups(el);
    return Object.keys(g).map(Number).sort(function (a, b) { return a - b; }).map(function (m) {
      var v = variantFor(el, m);
      if (!v) return null;
      return {
        id: v.id,
        quantity: g[m].length * mainQty,
        properties: {
          'Module': g[m].join(', '),
          _addon_for: opts.mainTitle || '',
          _sg_kabel_cfg: cfg,
          _sg_kabel_pro_set: String(g[m].length)
        }
      };
    }).filter(Boolean);
  }

  /* ---- Sicherheitsnetz vor dem Warenkorb ------------------------------ */

  /* Gleiche Suche wie die Konfiguratoren: Formular um den Block, sonst in
     der Section, sonst das erste Produktformular der Seite. */
  function formFor(el) {
    var section = el.closest('.shopify-section');
    return el.closest('form[is="product-form"]') ||
      el.closest('form[action*="/cart/add"]') ||
      (section && section.querySelector('form[is="product-form"]')) ||
      (section && section.querySelector('form[action*="/cart/add"]')) ||
      document.querySelector('form[is="product-form"]') ||
      document.querySelector('form[action*="/cart/add"]');
  }

  /* Prueft gegen den live geladenen Bestand, nicht gegen data-variants. */
  function blocked(el) {
    if (isOff(el)) return false;
    return lengths(el).some(function (m) {
      var v = variantFor(el, m);
      if (!v) return true;
      if (stock && Object.prototype.hasOwnProperty.call(stock, v.id)) return !stock[v.id];
      return v.a === false;
    });
  }

  function reportBlocked(el, wasOff) {
    var nowOff = isOff(el);
    showError(el, nowOff && !wasOff ? MSG_OFF_BLOCKED : MSG_BLOCKED);
    if (!nowOff) openPanel(el, true);
    try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { el.scrollIntoView(); }
  }

  /* Capture-Phase: laeuft vor den Submit-Listenern der Konfiguratoren.
     Ist der Bestand frisch und alles lieferbar, laeuft der Submit normal.
     Sonst kurz anhalten, Bestand holen und erst dann erneut absenden. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form._sgkBypass) { form._sgkBypass = false; return; }

    var el = null;
    Array.prototype.some.call(document.querySelectorAll('[data-sg-kabel]'), function (k) {
      if (formFor(k) === form) { el = k; return true; }
      return false;
    });
    if (!el) return;
    showError(el, '');

    var wasOff = isOff(el);
    if (wasOff) return;
    var fresh = stock && Date.now() - stockAt < FRESH_MS;
    if (fresh && !blocked(el)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (fresh) {
      applyStock(el);
      reportBlocked(el, wasOff);
      return;
    }

    var submitter = e.submitter || null;
    refresh(el).then(function (touched) {
      if (touched || isOff(el) !== wasOff) { reportBlocked(el, wasOff); return; }
      form._sgkBypass = true;
      try {
        if (form.requestSubmit) {
          if (submitter && submitter.form === form) form.requestSubmit(submitter);
          else form.requestSubmit();
        } else {
          form._sgkBypass = false;
          var btn = form.querySelector('[type="submit"], button[name="add"]');
          if (btn) { form._sgkBypass = true; btn.click(); }
        }
      } catch (err) {
        form._sgkBypass = false;
      }
    });
  }, true);

  /* ---- Bedienung --------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-sg-kabel-toggle]') : null;
    if (!btn) return;
    var el = btn.closest('[data-sg-kabel]');
    if (!el) return;
    e.preventDefault();
    var open = btn.getAttribute('aria-expanded') !== 'true';
    openPanel(el, open);
    if (open) refresh(el);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.tagName !== 'SELECT') return;
    var el = t.closest('[data-sg-kabel]');
    if (!el || !t.value) return;
    var m = parseInt(t.value, 10);
    if (!availableFor(el, m)) { changed(el); return; }
    showError(el, '');
    if (t.matches('[data-sg-kabel-all]')) {
      lines(el).forEach(function (line) { line.setAttribute('data-value', t.value); });
    } else {
      var line = t.closest('[data-sg-kabel-mod]');
      if (!line) return;
      line.setAttribute('data-value', t.value);
    }
    changed(el);
  });

  window.SGDcKabel = {
    find: function (scope) { return (scope || document).querySelector('[data-sg-kabel]'); },
    deltaCents: deltaCents,
    lengths: lengths,
    setLengths: setLengths,
    cartConfigId: cartConfigId,
    cartItems: cartItems
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('product:rerender', function () { setTimeout(initAll, 0); });

  document.dispatchEvent(new CustomEvent('sg:dc-kabel:ready'));
})();
